import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  LOCALE_ID,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import {
  LucideAngularModule,
  Gauge,
  Check,
  Loader,
  Download,
  X,
  Building,
  Sun,
  MessagesSquare,
  Home,
  Lightbulb,
  TrendingDown,
  LayoutGrid,
  ListIcon,
  PanelLeft,
  SlidersHorizontal,
  Users,
  Settings,
  LogOut,
  SquareKanban,
  BarChart2,
  TrendingUp,
  Calendar,
  User,
  Bell,
  CircleChevronDown,
  Mail,
  RadioTower,
  CalendarDays,
  CheckCircle,
  Slash,
  UserCheck,
  FileText,
  List,
  MapPin,
  FileCheck,
  Clock,
  BarChart3,
  PieChart,
  Columns2,
  CalendarRange,
  Send,
  PlusCircle,
  MessageSquarePlus,
  Calculator,
  Receipt,
  LifeBuoy,
  HelpCircle,
  Video,
  UserCog,
  Settings2,
  MenuIcon,
  Droplets,
  Thermometer,
  Flame,
  Snowflake,
  Wind,
  Zap,
  ChevronLeft,
  ChevronRight,
  ReceiptText,
  MessageSquareMore,
  Camera,
  Droplet,
  Archive,
  BellRing,
  ArrowRight,
  Activity,
  Plus,
  Trash2,
} from 'lucide-angular';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';

import { BrandingService } from './_core/branding.service';
import { MessageService } from 'primeng/api';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './_core/auth.interceptor';
import GomezPreset from './gomez-preset';
import { APP_ICONS } from './_core/lucide-icons';

registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes),
    { provide: LOCALE_ID, useValue: 'es' },
    provideAppInitializer(() => {
      const brandingService = inject(BrandingService);
      return brandingService.loadBrandingConfig();
    }),
    providePrimeNG({
      theme: {
        preset: GomezPreset,
        options: {
          darkModeSelector: 'none',
          cssLayer: {
            name: 'primeng',
            order: 'bootstrap, primeng',
          },
        },
      },
    }),

    importProvidersFrom(LucideAngularModule.pick(APP_ICONS)),

    MessageService,
  ],
};
